import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IDistributionBatchRecord } from "../../../config/types";
import { AppThunk } from "../..";

const initialState:Partial<IDistributionBatchRecord>  = {

};
export const batchDistributionCart = createSlice({
  name: "batchDistributionCart",
  initialState,
  reducers: {
    update: (_state, action: PayloadAction<IDistributionBatchRecord>) => {
      return action.payload;
    },
  },
});
export const { update } = batchDistributionCart.actions;
export const updateBatchDistributionCart=(data:IDistributionBatchRecord):AppThunk=> async (dispatch)=>{
  dispatch(update(data));
}
export default batchDistributionCart.reducer;
